import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-table-cloneable', 'addRow', 'Pridėti eilutę');
Labels.set('ui-table-cloneable', 'removeRow', 'Ištrinti eilutę');
